// extracted by mini-css-extract-plugin
module.exports = {"Page404":"Page404_Page404__Dedt_","Title":"Page404_Title__1nLim","Link":"Page404_Link__cT9ch"};